module.exports = __webpack_public_path__ + "img/7.39ad2c4e.jpg";